export const DEFAULT_SIDEBAR_WIDTH = '240px';

// Wider sidebar for the chat-based saved-search editor - the map still needs
// to stay visible, so this isn't the full ~960px ChatView is designed for.
export const CHAT_SIDEBAR_WIDTH = '420px';
